module.exports = __webpack_public_path__ + "static/media/niels-joergen.d136fe62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/niels-joergen.jpg
// module id = 608
// module chunks = 0